<template>
    <div>
<!--        Ticket assigned to-->
<!--        <strong>{{ $_.get(activity.payload, "assignedUserName") }}</strong>-->
<!--        by-->
<!--        <strong>{{ getActorName() }}</strong>-->
        <span v-html="$t('notification.ticketAssigned', {user1: getActorName(), user2:$_.get(activity, 'payload.assignedUserName')})"></span>
        <span class="quote" v-if="$_.get(activity, 'payload.ticketSubject')">
            Ticket subject =
            {{ $_.get(activity, "payload.ticketSubject") }}
        </span>

    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "TicketAssigned",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        getActorName() {
            if (this.activity.actor === "user") {
                return this.$_.get(this.activity, "actorUser.name");
            } else if (this.activity.actor === "visitor") {
                return this.$_.get(this.activity, "refVisitor.fullname");
            } else if (this.activity.actor === "chatbot") {
                return "Chatbot";
            } else if (this.activity.actor === "system") {
                return "System";
            }
        },
    },
});
</script>

<style scoped lang="scss"></style>
